import React from 'react';

export default function CardProductLoading() {
    return (
        <div className="card card--product card--link text--sm text-decoration-none">
            <div className="card__header">
                <div className="loader--skeleton" style={{ width: '100%', paddingTop: '66.66%' }}></div>
            </div>
            <div className="card-body flex-column p-6 d-none d-md-flex">
                <p className="h6 mb-1 loader--skeleton">
                    &nbsp;
                </p>
                <p className="mb-1 text--sm text-truncate loader--skeleton">
                    &nbsp;
                </p>
                <p className="mb-1 text--sm text-truncate loader--skeleton">
                    &nbsp;
                </p>
                <p className="mb-1 text--sm text-truncate loader--skeleton">
                    &nbsp;
                </p>
                <div className="d-none d-md-flex justify-content-between mt-8">
                    <div></div>
                    <div className="loader--skeleton" style={{ width: '80px', height: '40px' }}></div>
                </div>
            </div>
            <div className="card-body d-flex flex-column pl-4 d-md-none">
                <div className="row flex-column gutters-0 gutters-md-1 mb-0 mb-md-2">
                    <p className="text--12 mb-1 loader--skeleton">
                        &nbsp;
                    </p>
                    <p className="text--12 mb-1 loader--skeleton">
                        &nbsp;
                    </p>
                    <p className="text--12 mb-1 loader--skeleton">
                        &nbsp;
                    </p>
                    <p className="text--12 mb-1 loader--skeleton">
                        &nbsp;
                    </p>
                </div>
            </div>
        </div>
    );
}
